// extracted by mini-css-extract-plugin
export default {"commentsCountButton":"_32lfw"};